var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "bindlogo"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  })])], 1)]), _c('div', {
    staticClass: "author"
  }, [_c('h3', [_vm._v("绑定手机号")]), _c('el-form', {
    ref: "form",
    staticClass: "bindphone",
    attrs: {
      "model": _vm.form,
      "label-width": "80px",
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入手机号"
    }
  }, [_c('div', {
    staticClass: "code"
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11"
    },
    model: {
      value: _vm.form.mobileNo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mobileNo", $$v);
      },
      expression: "form.mobileNo"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "短信验证码"
    }
  }, [_c('div', {
    staticClass: "code"
  }, [_c('el-input', {
    attrs: {
      "maxlength": "6"
    },
    model: {
      value: _vm.form.smsCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "smsCode", $$v);
      },
      expression: "form.smsCode"
    }
  }), _c('span', {
    class: {
      'active': _vm.isCode
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.isCode ? "".concat(_vm.count, "s") : '获取验证码'))])], 1)]), _c('el-form-item', [_c('div', {
    staticClass: "bind",
    on: {
      "click": _vm.wxLoginCallBack
    }
  }, [_vm._v("登录并绑定")]), _c('p', [_vm._v("请绑定一个手机号码，用于登录和找回密码")])])], 1)], 1), _c('Footer', {
    attrs: {
      "isFixed": "true"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };